<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import IdCell from '../Dashboards/FilterTable/IdCell.svelte';
	import moment from 'moment';
	import PlatformCell from '../Dashboards/FilterTable/PlatformCell.svelte';
	import DeleteCell from '../Dashboards/FilterTable/DeleteCell.svelte';
	import MixListCell from '../Dashboards/FilterTable/MixListCell.svelte';
	import type { Segment } from 'Segments';
	import SimpleTable from '../../SimpleTable.svelte';

	export let data = [];

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('dispatchRefresh');
	}

	const columns = [
		{
			key: 'id',
			title: 'ID',
			value: (v: Segment) => v.id,
			class: 'id',
			headerClass: 'id',
			renderComponent: {
				component: IdCell
			}
		},
		{
			key: 'name',
			title: 'Name',
			value: (v: Segment) => v.name,
			class: 'segment-name',
			headerClass: 'segment-name',
			searchValue: (v: Segment) => v.name,
			sortable: true
		},
		{
			key: 'created',
			title: 'Created at',
			value: (v: Segment) => v.firstRun,
			renderValue: (v: Segment) =>
				v.firstRun !== null ? moment(v.firstRun).format('MM/DD/YYYY') : '',
			class: 'first-run',
			headerClass: 'first-run',
			sortable: true
		},
		{
			key: 'mixlist',
			title: 'Segment combination',
			value: (v: Segment) => v.combined,
			class: 'socdemo',
			headerClass: 'socdemo',
			renderComponent: {
				component: MixListCell
			}
		},
		{
			key: 'platform',
			title: 'Platform import',
			value: (v: Segment) => v.id,
			class: 'platform',
			headerClass: 'platform',
			renderComponent: {
				component: PlatformCell
			}
		},
		{
			key: 'delete',
			title: 'Actions',
			value: (v: Segment) => v.id,
			class: 'delete',
			headerClass: 'delete',
			renderComponent: {
				component: DeleteCell
			}
		}
	];
</script>

<SimpleTable rows={data} {columns} sortBy="created" sortOrder={-1} on:refresh={dispatchDeleted} />
